/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ParkingPlace } from '../../models/parking-place';

export interface ApiParkingPlaceCreateParkingPlacePost$Plain$Params {
      body?: ParkingPlace
}

export function apiParkingPlaceCreateParkingPlacePost$Plain(http: HttpClient, rootUrl: string, params?: ApiParkingPlaceCreateParkingPlacePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingPlace>> {
  const rb = new RequestBuilder(rootUrl, apiParkingPlaceCreateParkingPlacePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ParkingPlace>;
    })
  );
}

apiParkingPlaceCreateParkingPlacePost$Plain.PATH = '/api/ParkingPlace/CreateParkingPlace';
